<template>
  <div class="tx-app-container" v-cloak>
    <div id="tx-toast-container"></div>
    <Toast />
    <template v-if="true">
      <!-- <TxHeader /> -->
      <!-- <TxAccount /> -->
      <!-- <equipment_tips /> -->
      <!-- <TxRule /> -->
      <!-- <TxShare :is_show="false" /> -->
      <!-- <TxJoin /> -->
      <Main />
    </template>
    <template v-else>
      <div class="code-wraper f-center">
        <div class="tx-border f-center">
          <QrcodeVue :size="300" :value="computedHref" />
        </div>
        <div class="code-tips f-center">
          <span class="buy-tips">请少侠使用手机扫码</span>
          <span class="buy-tips">参与活动</span>
        </div>
      </div>
    </template>
  </div>
</template>
<script setup>
import 'whatwg-fetch';
import QrcodeVue from 'qrcode.vue';
import { inject, onMounted, reactive, defineAsyncComponent } from 'vue';
// import lazyLoad from './components/lazyLoad.vue';
import usePerformanceMetrics from './plugins/vue/usePerformance';
usePerformanceMetrics();
// 检测资源
import { generateFingerprint } from './utils/generateFingerprint';
import eventEmitter from '@utils/event';
import Toast from './components/toast.vue';
import useWeChatEnv from './plugins/vue/useWeChatOrMiniProgram';
import getQueryParams from './utils/getQueryParams';
import stringToBool from './utils/stringToBool';
import Main from './pages/main.vue';
const {
  set_token,
  set_utm_source,
  set_extra,
  set_share_id,
  set_channel,
  is_mobile,
} = inject('GlobalStore');
const computedHref = computed(() => {
  return window.location.href;
});

const { isWeChat, isMiniProgram } = useWeChatEnv();
const current_page = ref('main');
// 简单实现一个路由

onMounted(async () => {
  let token = getQueryParams()['token'];
  if (token) {
    set_token(token);
  }

  let utm_source = getQueryParams()['utm_source'];
  if (utm_source && stringToBool(utm_source)) {
    set_utm_source(utm_source);
  }

  let extra = getQueryParams()['extra'];
  if (extra && stringToBool(extra)) {
    set_extra(extra);
  }
  window.figureCode = generateFingerprint();

  let shareId = getQueryParams()['share_id'];
  if (shareId) {
    set_share_id(shareId);
  }

  if (isWeChat.value) {
    set_channel('wx');
  } else if (isMiniProgram.value) {
    set_channel('xcx');
  }

  eventEmitter.on('go', (value) => {
    current_page.value = value;
  });

  eventEmitter.on('account', (value) => {
    state.is_show_account = value;
  });
});
</script>

<style lang="scss">
.tx-app-container {
  width: 100%;
  height: 100%;
}

.empty {
  height: 0px;
  width: 100%;
}

.code-wraper {
  width: 100vw;
  height: 100vh;
  background-color: #242424;
  color: white;
  flex-direction: column;
}

.tx-border {
  width: 315px;
  height: 315px;
  background-color: white;
}

.code-tips {
  flex-direction: column;
  margin-top: 20px;
  font-size: 50px;
}
</style>
